// --更新英雄评分数据
module.exports = {
    UPDATE_SCROE : "StrongerEvent.UPDATE_SCROE"
}


